import { HttpClient } from '@angular/common/http';
import { isPlatformBrowser } from '@angular/common';

import { TranslateBrowserLoader } from './translate-loader.browser';

export function UniversalTranslateLoader(http: HttpClient, platformId: Object) {
  if (isPlatformBrowser(platformId)) {
    return new TranslateBrowserLoader(http);
  } else {
    const { TranslateServerLoader } = require('./translate-loader.server');

    return new TranslateServerLoader();
  }
}
